var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.291,
    height: 10.814,
    viewBox: "0 0 9.291 10.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "italic",
    transform: "translate(0.5 0.671)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1023",
    "data-name": "Line 1023",
    x1: 5.63,
    transform: "translate(2.661 0)",
    fill: "none",
    stroke: "#a5a5a5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1024",
    "data-name": "Line 1024",
    x1: 4.89,
    transform: "translate(0 9.643)",
    fill: "none",
    stroke: "#a5a5a5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1025",
    "data-name": "Line 1025",
    x1: 4.692,
    y2: 9.384,
    transform: "translate(1.722 0)",
    fill: "none",
    stroke: "#a5a5a5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic2);
export default __webpack_public_path__ + "static/media/italic2.1252514ed6a7a0c0a3cee6db1b85543f.svg";
export { ForwardRef as ReactComponent };